<div class="sky-card">
  <div class="sky-card-header">
    <h1 class="h2 mb-0">Realms</h1>
  </div>
  <div class="sky-card-body">
    <app-wiki-link [wiki]="{href: 'https://sky-children-of-the-light.fandom.com/wiki/Realms'}"></app-wiki-link>
  </div>
</div>

<div class="grid grid-3 mt">
  <div class="sky-card p-rel" *ngFor="let realm of visibleRealms">
    <div class="sky-card-header">
      <h2 class="h3 mb-0">{{realm.name}}</h2>
    </div>
    <!-- Image -->
    <div class="sky-card-body">
      <div *ngIf="realm.imageUrl" class="p-rel img sky-border-solid"
        [style.background-image]="'url('+realm.imageUrl+')'"
        [style.background-position]="realm.imagePosition || undefined">
      </div>
      <!-- Overview --> <!-- For now only show overview if realm has spirits. -->
      <a class="item link mt" [routerLink]="['/realm', realm.guid]">
        <mat-icon class="menu-icon">article</mat-icon>
        <span class="menu-label">Overview</span>
      </a>
      <!-- Areas -->
      <!-- <div class="mt item areas">
        Areas
      </div> -->
    </div>
  </div>
</div>
